// Composer Studio — 선택 인디케이터 오버레이(맨 위). CSS outline은 노드 페인트순서라 이웃에 덮여
// 일부만 보이는 문제가 있어, 선택 노드 rect를 canvas 기준으로 계산해 RenderTemplate 뒤(맨 위)에 그린다.
// 좌표 패턴은 ResizeHandles.tsx와 동일(getBoundingClientRect, canvas 상대).

import { getNodeRects } from './canvasRect';

export function SelectionOverlay({
  canvas,
  nodeId,
}: {
  canvas: HTMLElement | null;
  nodeId: string | null;
}) {
  if (!canvas || !nodeId) return null;
  // 표가 페이지 분할되면 같은 node-id 조각이 여러 개 — 조각마다 outline을 그려 전체 표를 덮는다
  // (일반 표는 조각 1개라 기존과 동일).
  const rects = getNodeRects(canvas, nodeId);
  if (rects.length === 0) return null;
  return (
    <div style={{ position: 'absolute', inset: 0, pointerEvents: 'none', zIndex: 38 }}>
      {rects.map((r, i) => (
        <div
          key={i}
          style={{
            position: 'absolute',
            top: r.top,
            left: r.left,
            width: r.width,
            height: r.height,
            outline: '2px solid #4f46e5', // brand-600
            outlineOffset: '1px',
            pointerEvents: 'none',
          }}
        />
      ))}
    </div>
  );
}
